import _ from 'lodash';
import { IHttpClient } from '@wix/http-client';
import log from '@wix/wix-log';
import { WixNextApiRequest, WixNextApiResponse } from '@common/types';
import createKeyValueStoreAPI from '@services/KeyValueAPI';

const TTL_MILLIS_FOR_CIDX = 30 * 60 * 60 * 1000; // 0.5 hour
const TTL_MILLIS_FOR_USER_GUID = 30 * 24 * 60 * 60 * 60 * 1000; // 30 days

const createCurrencyPreferencesKey = (id: string) =>
  `${id}_currency_preferences`;

interface CurrencyPreferencesKeyProp {
  key: string;
  type: 'cidx' | 'uidx' | 'none';
}

export async function getCurrencyPreferencesKey({
  req,
  res,
}: {
  req: WixNextApiRequest;
  res: WixNextApiResponse;
}): Promise<CurrencyPreferencesKeyProp> {
  let result: CurrencyPreferencesKeyProp = { key: '', type: 'none' };
  try {
    const { identificationData } =
      await res.locals.appContext.apiGwClient.identity(req.aspects);
    const identities = identificationData?.identities;
    const userGuid = _.find(
      identities,
      (identity) => identity?.person?.type === 0,
    )?.person?.id;
    const cidx = req.cookies._wixCIDX!;
    if (userGuid || cidx) {
      result = userGuid
        ? { type: 'uidx', key: createCurrencyPreferencesKey(userGuid) }
        : { type: 'cidx', key: createCurrencyPreferencesKey(cidx) };
    }
  } catch (err: any) {
    const { message, stack } = err;
    log('hire ssr')
      .withAspects(req.aspects)
      .error(`error w/ hire ssr getCurrencyPreferencesKey ${message} ${stack}`);
  }
  return result;
}

export async function getStoredCurrencyPreferences({
  req,
  res,
}: {
  req: WixNextApiRequest;
  res: WixNextApiResponse;
}) {
  const keyValueAPI = createKeyValueStoreAPI(
    res.locals.appContext,
    req.aspects,
  );
  try {
    const currencyPreferences = await getCurrencyPreferencesKey({ req, res });
    if (currencyPreferences.type !== 'none') {
      return keyValueAPI.getValue(currencyPreferences.key);
    }
    return null;
  } catch (err: any) {
    const { message, stack } = err;
    log('currencyPreferences')
      .withAspects(req.aspects)
      .error(`error w/ getStoredCurrencyPreferences ${message} ${stack}`);
    return null;
  }
}

export async function setStoredCurrencyPreferences({
  req,
  res,
  value,
}: {
  req: WixNextApiRequest;
  res: WixNextApiResponse;
  value: any;
}) {
  const keyValueAPI = createKeyValueStoreAPI(
    res.locals.appContext,
    req.aspects,
  );
  try {
    const currencyPreferences = await getCurrencyPreferencesKey({ req, res });
    if (currencyPreferences.type !== 'none') {
      const ttlMillis =
        currencyPreferences.type === 'uidx'
          ? TTL_MILLIS_FOR_USER_GUID
          : TTL_MILLIS_FOR_CIDX;
      return keyValueAPI.setValue({
        key: currencyPreferences.key,
        value,
        ttlMillis,
      });
    }
    return null;
  } catch (err: any) {
    const { message, stack } = err;
    log('hire ssr')
      .withAspects(req.aspects)
      .error(
        `error w/ hire ssr setStoredCurrencyPreferences ${message} ${stack}`,
      );
    return null;
  }
}

export async function setCurrencyPreferencesRest({
  value,
  httpClient,
}: {
  value: any;
  httpClient: IHttpClient;
}) {
  try {
    const { data: currencyPreferences } = await httpClient.get<string>(
      `/api/currency/setCurrencyPreferences?value=${value}`,
    );
    return currencyPreferences;
  } catch (err: any) {
    return null;
  }
}
